import { useMatch } from 'react-router-dom';

import { ROUTES } from '@/constants';

interface RouteParams {
  id?: string;
  companyId?: string;
}

export const useRouteParams = (): RouteParams => {
  const companyPanelMatch = useMatch({
    path: `${ROUTES.companies}/:companyId${ROUTES.panels}/:id`,
    caseSensitive: false,
    end: false,
  });

  const directPanelMatch = useMatch({
    path: `${ROUTES.companies}${ROUTES.panels}/:id`,
    caseSensitive: false,
    end: false,
  });

  if (companyPanelMatch?.params) {
    return {
      id: companyPanelMatch.params.id,
      companyId: companyPanelMatch.params.companyId,
    };
  }

  if (directPanelMatch?.params) {
    return {
      id: directPanelMatch.params.id,
      companyId: undefined,
    };
  }

  return {};
};
